import { EventType, RelationType, Room } from 'matrix-js-sdk/src/matrix';

export const raiseHandKey = 'raise_hand';

interface GetLastRaiseHandEventProps {
  room: Room;
  eventId: string;
  expectedSender: string;
}

export const getLastRaiseHandEvent = ({ room, eventId, expectedSender }: GetLastRaiseHandEventProps) => {
  const relations = room.relations.getChildEventsForEvent(eventId, RelationType.Annotation, EventType.Reaction);
  const allEvents = relations?.getRelations() ?? [];

  if (!allEvents.length) return undefined;

  return allEvents.find(
    (reaction) =>
      reaction.event.sender === expectedSender &&
      reaction.getType() === EventType.Reaction &&
      reaction.getContent()?.['m.relates_to']?.key === raiseHandKey
  );
};

export const REACTIONS_FILTER = {
  room: {
    timeline: {
      types: ['m.reaction'],
    },
  },
};

export const REACTION_MESSAGE_LIMIT = 20;
export const REACTION_AGE_LIMIT_MINUTES = 20;
export const REACTION_MAX_FETCH_ATTEMPTS_COUNT = 3;
